import { Button, Tooltip } from "@mui/material";
import appLogo from "../../assets/images/applogo.png";
import "./trainer.css";
import MenuButton from "../widgets/menuButton";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import TopicOutlinedIcon from "@mui/icons-material/TopicOutlined";
import PremiumCard from "../widgets/premiumCard";
import { deleteToken } from "../../utilities/utility";
import Dashboard from "./dashboard";
import Header from "./header";
import { useState } from "react";
import { toast } from "react-toastify";
import YesNoDialog from "../widgets/ratulModal/YesNoDialog";
import MyAssessments from "./myAssessments";
import CreateAssessment from "./createAssessment";
import CreateButton from "../widgets/createButton";
import LeftMenuLogo from "../widgets/leftMenuLogo";
import QuestionLibrary from "./ql/questionLibrary";
import LiveAssessment from "./liveAssessment";
import Subscription from "../subscription/subscription";
import AReport from "../report/aReport";
import Profile from "../profile/profile";
import PreviewAssessment from "../widgets/previewAssessment";
import { useNavigate } from "react-router-dom";

const Trainer = () => {
  const loc = document.location.href.replace(/\/+$/, "");
  const keysUrl = loc.split("/");
  const a_code = keysUrl[4] || "my-dashboard";
  const navigate = useNavigate();
  const [collapse, setCollapse] = useState(false);
  const [planData, setPlanData] = useState();
  const [dopen, setDopen] = useState(false);

  const handleLogout = () => setDopen(true);
  const onNoResponse = () => setDopen(false);
  const onYesResponse = () => {
    deleteToken();
    document.location.href = "/login";
  };

  const createAssessment = () => {
    //setCollapse(true);      // If expanded, collapse it
    navigate("/trainer/create-assessment");
  };
  
  const myDashboard = () => navigate("/trainer/my-dashboard");
  const myAssessment = () => navigate("/trainer/my-assessments");
  const questionLibrary = () => navigate("/trainer/question-library");
  const subscription = () => navigate("/trainer/subscription");

  const renderMenuButton = (text, icon, onClick, isActive) => (
    collapse ? (
      <Tooltip title={text} placement="right">
        <div>
          <MenuButton
            collapse={collapse}
            onClick={onClick}
            text={text}
            MenuIcon={icon}
            active={isActive}
          />
        </div>
      </Tooltip>
    ) : (
      <MenuButton
        collapse={collapse}
        onClick={onClick}
        text={text}
        MenuIcon={icon}
        active={isActive}
      />
    )
  );

  return (
    <div className="trainer_dashboard">
      <YesNoDialog
        dopen={dopen}
        message="Are you sure you want to logout?"
        setDopen={setDopen}
        onNoResponse={onNoResponse}
        onYesResponse={onYesResponse}
      />
      <div className="left_menu_box">
        <LeftMenuLogo collapse={collapse} />
        <div style={{ marginTop: 16, marginLeft: 12, marginRight: 12 }}>
          {collapse ? (
            <Tooltip title="Create Assessment" placement="right">
              <div>
                <CreateButton collapse={collapse} onClick={createAssessment} />
              </div>
            </Tooltip>
          ) : (
            <CreateButton collapse={collapse} onClick={createAssessment} />
          )}
        </div>

        {renderMenuButton("My Dashboard", DashboardCustomizeOutlinedIcon, myDashboard, a_code === "my-dashboard")}
        {renderMenuButton("My Assessment", AssessmentOutlinedIcon, myAssessment, a_code === "my-assessments")}
        {renderMenuButton("Question Library", LibraryBooksOutlinedIcon, questionLibrary, a_code === "question-library")}
        {/* {renderMenuButton("Subscription", TopicOutlinedIcon, subscription, a_code === "subscription")} */}
        {renderMenuButton("Logout", LogoutIcon, handleLogout, false)}

        {/* {!collapse && <PremiumCard planData={planData} setPlanData={setPlanData} />} */}
      </div>

      <Header title={a_code} collapse={collapse} setCollapse={setCollapse} />

      <div className="dashboard_content" style={{ marginLeft: collapse ? 100 : 256 }}>
        {{
          "create-assessment": <CreateAssessment setCollapse={setCollapse} />,
          "my-dashboard": <Dashboard planData={planData} />,
          "my-assessments": <MyAssessments />,
          "trainer-profile": <Profile />,
          "question-library": <QuestionLibrary />,
          "report": <AReport />,
          "subscription": <Subscription planData={planData} />,
          "live-assessment": <LiveAssessment setCollapse={setCollapse} />,
          "preview":<PreviewAssessment />
        }[a_code] || <Dashboard />}
      </div>
    </div>
  );
};

export default Trainer;
